var Review = /** @class */ (function () {
    function Review(obj, id) {
        if (id) {
            this.id = id;
        }
        this.name = obj.name;
        this.body = obj.body;
        this.rating = obj.rating;
        this.approved = obj.approved;
        if (obj.created_at) {
            this.created_at = obj.created_at;
        }
        if (obj.user_email) {
            this.user_email = obj.user_email;
        }
        if (obj.product_name) {
            this.product_name = obj.product_name;
        }
    }
    Object.defineProperty(Review.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "Name", {
        get: function () {
            return this.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "Body", {
        get: function () {
            return this.body;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "Rating", {
        get: function () {
            return this.rating;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "Approved", {
        get: function () {
            return this.approved;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "CreatedAt", {
        get: function () {
            return this.created_at;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "UserEmail", {
        get: function () {
            return this.user_email;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Review.prototype, "ProductName", {
        get: function () {
            return this.product_name;
        },
        enumerable: false,
        configurable: true
    });
    return Review;
}());
export { Review };
export function createReview(obj, id) {
    return new Review(obj, id);
}
export function createReviews(rawReviews) {
    var reviews = [];
    var rawReviewsData = rawReviews.data;
    for (var _i = 0, rawReviewsData_1 = rawReviewsData; _i < rawReviewsData_1.length; _i++) {
        var rawReview = rawReviewsData_1[_i];
        var review = createReview(rawReview.attributes, rawReview.id);
        reviews.push(review);
    }
    return reviews;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/product/review.ts
// module id = 128
// module chunks = 0